<script setup lang="ts">
import { onMounted, ref } from 'vue';

import Card from '@/components/Card.vue';
import { useModuleStore } from '@/stores/module';
import type { Module } from '@/types/module';

const moduleStore = useModuleStore();
const modules = ref<Module[]>();
const isInitializing = ref<boolean>(true);

onMounted(async () => {
    modules.value = await moduleStore.get();
    isInitializing.value = false;
});
</script>

<template>
    <v-fade-transition>
        <div v-if="!isInitializing && modules">
            <v-row v-if="modules.length > 0" class="justify-md-start justify-center">
                <Card
                    v-for="module in modules"
                    :key="module._id"
                    :name="module.name"
                    :imageUrl="module.imageUrl"
                    :route="`/module-overzicht/${module.name}`"
                    :text="module.description"
                />
            </v-row>
            <div v-else>
                <p>Er zijn nog geen modules toegevoegd</p>
            </div>
        </div>
    </v-fade-transition>
</template>
